import { type InvoiceAttachment } from './invoice-attachment';
import { type InvoiceLineItem } from './invoice-line-item';
import { type ValidationError } from './validation-error';

export type OtStatus =
	'Approved' | 'Cancelled' | 'Disputed' | 'Saved' | 'Submitted';
export type OiStatus =
	| 'Approved'
	| 'Cancelled'
	| 'Disputed'
	| 'Paid'
	| 'Saved'
	| 'Stalled'
	| 'Submitted';

export class Invoice {
	public internalId!: number;
	public ticketNumber!: string;
	public requisitioner!: string;
	public description!: string;
	public lineServiceDateFrom!: string;
	public lineServiceDateTo!: string;
	public lineDescription!: string;
	public location!: string;
	public units!: string;
	public afe?: string;
	public costCenter?: string;
	public amount!: number;
	public tax?: number;
	public discount?: number;
	public taxTotal!: number;
	public nsStatus!: string;
	public invoiceNumber!: string;
	public jobLocation!: string;
	public name!: string;
	public invoiceId!: string;
	public po?: string;
	public afeloe?: string;
	public glCode?: string;
	public area?: string;
	public cc?: string;
	public category?: string;
	public woNumber?: string;
	public selected?: boolean;
	public date!: string;
	public files!: InvoiceAttachment[];
	public primaryPdf?: InvoiceAttachment;
	public invoiceLines?: InvoiceLineItem[];
	public salesOrderID!: string;
	public sapDescription!: string;
	public parentCompany!: string;
	public shipDate!: string;
	public assignedTo?: string;
	public openTicketId?: string;
	public openInvoiceId?: number;
	public enverusRequisitioner?: string;
	public rkSubmitter?: string;
	public invoiceDate!: string;
	public majorMinor?: string;
	public needsSpanDate!: boolean;

	public platform?: string;
	public otStatus?: OtStatus;
	public oiStatus?: OiStatus;

	public serviceDate?: string;

	public useOpenTicket!: boolean;

	public errors?: ValidationError[];
	public warnings?: ValidationError[];
	public submissionErrors?: ValidationError[];
	public submissionWarnings?: ValidationError[];
	public isSubmitting!: boolean;
	public ticketComplianceErrors?: ValidationError[];


	public get canSubmit(): boolean {
		// disable all oi bound tickets
		return this.useOpenTicket && !this.otStatus;
	}

	private enverusBaseUrl = 'https://www.openinvoice.com/docp';

	public get openInvoiceUrl(): string | null {
		if (!this.openInvoiceId) return null;

		return `${ this.enverusBaseUrl }/theme/index.xhtml?targetUrl=%252Fdocp%252FopenInvoice%252Fmain%252FinvoiceInput%253FnavigateFromApp%253DinvoiceApp%2526documentId%3D${ this.openInvoiceId }`;
	}

	public get openTicketUrl(): string | null {
		if (!this.openTicketId) return null;

		return `${ this.enverusBaseUrl }/app/ticket/index.html#!/receipt/detail/${ this.openTicketId }?navigateFrom=ticketApp`;
	}

	public get errorStatus(): string {
		if (this.errors?.length) return 'errors';
		if (this.warnings?.length) return 'warnings';
		return 'none';
	}

	public get submissionErrorStatus(): string {
		if (this.submissionErrors?.length) return 'errors';
		if (this.submissionWarnings?.length) return 'warnings';
		return 'none';
	}

	public get ticketComplianceStatus(): string {
		if (this.ticketComplianceErrors?.length) return 'errors';
		return 'none';
	}

	public get otDisplayStatus(): string | null {
		if (!this.otStatus) return null;
		const status = this.otStatus;
		return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
	}

	public get oiDisplayStatus(): string | null {
		if (!this.oiStatus) return null;
		const status = this.oiStatus;
		return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
	}
}
